import { useCallback, useMemo } from 'react'

import { getPathWithoutLocale } from './getPathWithoutLocale'
import { useHeaderPathname } from './useHeaderPathname'

export const useActiveLink = () => {
	const pathname = useHeaderPathname()

	const pathWithoutLocale = useMemo(
		() => getPathWithoutLocale(pathname),
		[pathname]
	)

	const isLinkActive = useCallback(
		(linkPath: string): boolean => {
			const linkPathNorm = linkPath.replace(/^\//, '').split('?')[0]
			const pathNorm = pathWithoutLocale.replace(/^\//, '').split('?')[0]
			if (!pathNorm) return linkPathNorm === '' || linkPath === '/'
			if (!linkPathNorm) return pathNorm === ''
			return pathNorm === linkPathNorm || pathNorm.startsWith(linkPathNorm + '/')
		},
		[pathWithoutLocale]
	)

	return { isLinkActive, pathname, pathWithoutLocale }
}
